import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import { apiUrl, cart, fetchProducts, formatPrice } from '../shop';

/** Plain checkout page: review the cart, remove items, enter an address and place the order. */
export default class CheckoutPage extends Page {
  items = cart.items();
  shippingName = '';
  shippingAddress = '';
  placing = false;
  placedOrder = null;
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Checkout');
    this.refreshPrices();
  }

  /** Show current names/prices and drop products that were deleted since they were added. */
  refreshPrices() {
    fetchProducts(this.items.map(item => item.id)).then(products => {
      const updated = cart.items().filter(item => products.some(p => p.id === item.id)).map(item => {
        const product = products.find(p => p.id === item.id);
        return {
          ...item,
          name: product.name,
          price: product.price,
          image_url: product.image_url
        };
      });
      cart.replace(updated);
      this.items = updated;
      m.redraw();
    }).catch(() => {});
  }
  total() {
    return this.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }
  view() {
    return m("div", {
      className: "ShopPage container"
    }, this.placedOrder ? this.confirmation() : this.checkout());
  }
  confirmation() {
    return m("div", null, m("h2", null, "Thank you!"), m("p", null, "Order #", this.placedOrder.id, " has been placed. Total: ", formatPrice(this.placedOrder.total), "."), m(Button, {
      className: "Button",
      onclick: () => m.route.set(app.route('index'))
    }, "Back to the forum"));
  }
  checkout() {
    if (!this.items.length) {
      return m("div", null, m("h2", null, "Checkout"), m("p", null, "Your cart is empty. Use \"Add to cart\" on products in forum posts."));
    }
    return m("div", null, m("h2", null, "Checkout"), m("table", null, m("thead", null, m("tr", null, m("th", null, "Product"), m("th", null, "Price"), m("th", null, "Quantity"), m("th", null, "Subtotal"), m("th", null))), m("tbody", null, this.items.map(item => m("tr", null, m("td", null, item.name), m("td", null, formatPrice(item.price)), m("td", null, m("input", {
      className: "FormControl ShopQuantity",
      type: "number",
      min: 1,
      max: 100,
      value: item.quantity,
      onchange: e => this.setQuantity(item.id, Number(e.target.value))
    })), m("td", null, formatPrice(item.price * item.quantity)), m("td", null, m(Button, {
      className: "Button Button--link",
      onclick: () => this.remove(item.id)
    }, "Remove")))))), m("p", null, m("strong", null, "Total: ", formatPrice(this.total()))), app.session.user ? this.shippingForm() : m("p", null, m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, "Log in to place your order"), ' ', "Your cart is kept while you log in."));
  }
  shippingForm() {
    return m("form", {
      className: "ShopForm",
      onsubmit: this.placeOrder.bind(this)
    }, m("h3", null, "Shipping"), m("div", {
      className: "Form-group"
    }, m("label", null, "Full name"), m("input", {
      className: "FormControl",
      required: true,
      maxlength: 255,
      value: this.shippingName,
      oninput: e => this.shippingName = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", null, "Address"), m("textarea", {
      className: "FormControl",
      required: true,
      rows: 3,
      maxlength: 2000,
      value: this.shippingAddress,
      oninput: e => this.shippingAddress = e.target.value
    })), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.placing
    }, "Place order"));
  }
  setQuantity(id, quantity) {
    cart.setQuantity(id, quantity || 1);
    this.items = cart.items();
  }
  remove(id) {
    cart.remove(id);
    this.items = cart.items();
  }
  placeOrder(e) {
    e.preventDefault();
    this.placing = true;
    app.request({
      method: 'POST',
      url: apiUrl('/shop/orders'),
      body: {
        items: this.items.map(item => ({
          product_id: item.id,
          quantity: item.quantity
        })),
        shipping_name: this.shippingName,
        shipping_address: this.shippingAddress
      }
    }).then(order => {
      this.placedOrder = order;
      cart.clear();
      this.items = [];
    }).catch(() => {}) // the error alert is shown by app.request
    .finally(() => {
      this.placing = false;
      m.redraw();
    });
  }
}
flarum.reg.add('abdulrehman-shop', 'forum/components/CheckoutPage', CheckoutPage);